module.exports = __webpack_public_path__ + "static/3-b14da7959b2806860bd43d1d00606c08.svg";